import React, { useState } from 'react';
import { StyleSheet } from 'react-native';
import Box from '../Box/Box';
import { Text, Layout, ViewPager } from '@ui-kitten/components';
const styles = StyleSheet.create({
    tab: {
        height: 192,
        alignItems: 'center',
        justifyContent: 'center',
    },
});
const Kitten = (props) => {
    const [index, setIndex] = useState(0);
    return (<Box style={{ overflow: 'hidden' }}>
      <ViewPager selectedIndex={index} onSelect={setIndex}>
        <Layout level="2" style={styles.tab}>
          <Text category="h5">Tab 1</Text>
        </Layout>
        <Layout level="2" style={styles.tab}>
          <Text category="h5">Tab 2</Text>
        </Layout>
      </ViewPager>
    </Box>);
};
export default {
    Kitten,
};
//# sourceMappingURL=Swiper.js.map